import { BatterSingleSessionReportChartConfigDto, TableChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';

const BatterSingleSessionPitchByPitchStatsChartSidebar = (
  props: ChartConfigProps<TableChartConfigDto, BatterSingleSessionReportChartConfigDto>
) => {
  return (
    <TableChartSidebar
      chartId='BatterSingleSessionPitchByPitchStatsChart'
      chartKey='batterSingleSessionPitchByPitchStatsChartConfig'
      {...props}
    />
  );
};

export default BatterSingleSessionPitchByPitchStatsChartSidebar;
